import { createAsyncThunk } from '@reduxjs/toolkit';
import i18n from '../../../i18n';

import type {
  CheckEmailCommand,
  CheckEmailResponse,
  SignInCommand,
  SignUpCommand,
  SignUpResponse,
  SnsLinkCommand,
  SnsSelectCommand,
  SnsSignInCommand,
  SnsSignUpCommand,
} from '../Domain/repository/AuthRepository';
import type { AuthSession, SnsSignInResult } from '../Domain/entity/AuthTypes';
import { authUseCases } from './authUseCases';

export const signIn = createAsyncThunk<AuthSession, SignInCommand, { rejectValue: string }>(
  'auth/signIn',
  async (command, { rejectWithValue }) => {
    try {
      return await authUseCases.signIn.execute(command);
    } catch (error) {
      return rejectWithValue((error as Error).message ?? i18n.t('common.repositoryErrors.authSignInFailed'));
    }
  },
);

export const signUp = createAsyncThunk<SignUpResponse, SignUpCommand, { rejectValue: string }>(
  'auth/signUp',
  async (command, { rejectWithValue }) => {
  try {
      return await authUseCases.signUp.execute(command);
  } catch (error) {
      return rejectWithValue((error as Error).message ?? i18n.t('common.repositoryErrors.authSignUpFailed'));
  }
  },
);

export const checkEmail = createAsyncThunk<CheckEmailResponse, CheckEmailCommand, { rejectValue: string }>(
  'auth/checkEmail',
  async (command, { rejectWithValue }) => {
    try {
      return await authUseCases.checkEmail.execute(command);
    } catch (error) {
      return rejectWithValue((error as Error).message ?? i18n.t('common.repositoryErrors.checkEmailFailed', { code: 'unknown' }));
    }
  },
);

// SNS 인증 → 연결된 계정 목록 (세션은 만들지 않는다)
export const snsSignIn = createAsyncThunk<SnsSignInResult, SnsSignInCommand, { rejectValue: string }>(
  'auth/snsSignIn',
  async (command, { rejectWithValue }) => {
    try {
      return await authUseCases.snsSignIn.execute(command);
    } catch (error) {
      return rejectWithValue((error as Error).message ?? i18n.t('common.repositoryErrors.authSignInFailed'));
    }
  },
);

export const snsSelect = createAsyncThunk<AuthSession, SnsSelectCommand, { rejectValue: string }>(
  'auth/snsSelect',
  async (command, { rejectWithValue }) => {
    try {
      return await authUseCases.snsSelect.execute(command);
    } catch (error) {
      return rejectWithValue((error as Error).message ?? i18n.t('common.repositoryErrors.authSignInFailed'));
    }
  },
);

export const snsLink = createAsyncThunk<AuthSession, SnsLinkCommand, { rejectValue: string }>(
  'auth/snsLink',
  async (command, { rejectWithValue }) => {
    try {
      return await authUseCases.snsLink.execute(command);
    } catch (error) {
      return rejectWithValue((error as Error).message ?? i18n.t('common.repositoryErrors.authSignInFailed'));
    }
  },
);

export const snsSignUp = createAsyncThunk<AuthSession, SnsSignUpCommand, { rejectValue: string }>(
  'auth/snsSignUp',
  async (command, { rejectWithValue }) => {
    try {
      return await authUseCases.snsSignUp.execute(command);
    } catch (error) {
      return rejectWithValue((error as Error).message ?? i18n.t('common.repositoryErrors.authSignUpFailed'));
    }
  },
);

